import { isBrowser } from "../utils/isBrowser";
import { sleep } from "../utils/sleep";
import axios, { AxiosResponse } from 'axios';

// axios.defaults.validateStatus = () => true;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Cache-Control'] = 'no-store';
axios.defaults.headers.common['Pragma'] = 'no-cache';
axios.defaults.headers.common['Expires'] = '0';
axios.defaults.headers.common['Accept-Language'] = 'ar';

type JSON = { [key: string]: any };


interface RequestRetrial {
  max: number;
  sleepBetween: number; //ms
}


class HttpService {
  constructor(
    protected client = axios,
    protected requestRetrial: RequestRetrial = { max: 1, sleepBetween: 2000 }) {
  }


  async getJSON<T = JSON>(url: string, headers = {}) {
    const result = await this.performRequest({url, method: 'GET', headers}) as T;
    return result;
  }

  async postJSON<T = JSON, BT = JSON>(url: string, data: BT, headers = {}) {
    const result = await this.performRequest({url, method: 'POST', data: data!, headers}) as T;
    return result;
  }

  protected async performRequest(configs: {url: string, method: string, headers?: {[key: string] : string}, data?: JSON}) {
    let counter = 0;
    let res: AxiosResponse<any, any> = await this.client(configs);
    while (res.status !== 200 && counter <= this.requestRetrial.max) {
      res = await this.client(configs);
      if (counter === this.requestRetrial.max) {
        if (res.status >= 500) {
          console.error(`server error, failed ${this.requestRetrial.max} times`, JSON.stringify({text: res.statusText, configs}));
          throw new Error(res.statusText);
        }
        else return undefined;
      }
      counter++;
      await sleep(this.requestRetrial.sleepBetween);
    }
    return res.data;
  }
}



export const httpService = new HttpService();